import React from "react";
var __jsx = React.createElement;
import injectFBSnippet from '@anm/helpers/trackingSnippets/FBSnippet';
import injectGASnippet from '@anm/helpers/trackingSnippets/GASnippet';

var AnalyticScript = function AnalyticScript(_ref) {
  var id = _ref.id,
      scriptType = _ref.scriptType;

  switch (scriptType) {
    case 'ga':
      return __jsx("script", {
        dangerouslySetInnerHTML: {
          __html: injectGASnippet(id)
        }
      });

    case 'fb':
      return __jsx("script", {
        dangerouslySetInnerHTML: {
          __html: injectFBSnippet(id)
        }
      });

    default:
      return null;
  }
};

export default AnalyticScript;